export default __webpack_public_path__ + "static/media/mildpain.c4758c2c.svg";